// extracted by mini-css-extract-plugin
export default {"root":"LinkedLogo_root__zLyuX"};